import { useFormikContext } from 'formik'
import React from 'react'
import ScoreFields from './ScoreFields'

type Props = {
  type: 'PCL5' | 'ASRM' | 'OCIR' | 'ISI'
  questions: Array<{ key: string; label: string }>
}

const SumScoredQuestionnaireFields = ({ type, questions }: Props) => {
  const { setFieldValue, values } = useFormikContext<{ value: Record<string, number> }>()
  return <ScoreFields type={type} values={values} setFieldValue={setFieldValue} questions={questions} />
}

export default SumScoredQuestionnaireFields
